import { render, staticRenderFns } from "./ActionText.vue?vue&type=template&id=09c792a8&scoped=true&"
import script from "./ActionText.vue?vue&type=script&lang=ts&"
export * from "./ActionText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c792a8",
  null
  
)

export default component.exports